"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var BillingApiChargePayCheckResponseDto_1;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingApiChargePayCheckResponseDto = exports.BillingApiChargePayCheckProviderResponseDto = void 0;
const billing_core_charge_status_enum_1 = require("../../../../billing-core/billing-core-charge/types/enums/billing-core-charge-status.enum");
const billing_api_charge_response_dto_1 = require("./billing-api-charge-response.dto");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const types_1 = require("../../../billing-api-order/types");
const swagger_1 = require("../../../../swagger-fake");
const types_2 = require("../../../billing-api-account/types");
class BillingApiChargePayCheckProviderResponseDto {}
__decorate([(0, swagger_1.ApiProperty)({
  description: "Id провайдера поддерживающего приём платежа",
  format: "uuid"
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsUUID)(4), __metadata("design:type", String)], BillingApiChargePayCheckProviderResponseDto.prototype, "id", void 0);
exports.BillingApiChargePayCheckProviderResponseDto = BillingApiChargePayCheckProviderResponseDto;
let BillingApiChargePayCheckResponseDto = BillingApiChargePayCheckResponseDto_1 = class BillingApiChargePayCheckResponseDto {
  static fromLike(values) {
    const instance = (0, class_transformer_1.plainToInstance)(BillingApiChargePayCheckResponseDto_1, values);
    return instance;
  }
};
__decorate([(0, swagger_1.ApiProperty)({
  description: `Если результат описывает одно начисление, то статус этого начисления. 
    Если результат описывает группу начислений, то это вычисляемое значение:
    PAID - все оплачены
    PREPARE - можно отправлять на оплату, но могут быть уже оплаченные, см. hasPaid`,
  enum: billing_core_charge_status_enum_1.BillingCoreChargeStatusEnum,
  readOnly: true
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsEnum)(billing_core_charge_status_enum_1.BillingCoreChargeStatusEnum), __metadata("design:type", String)], BillingApiChargePayCheckResponseDto.prototype, "status", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Имеются начисления которые невозможно оплатить",
  type: 'boolean',
  nullable: true,
  readOnly: true
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsBoolean)(), __metadata("design:type", Object)], BillingApiChargePayCheckResponseDto.prototype, "hasImpossible", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "В массиве начислений какие-то или все уже оплачены",
  type: 'boolean',
  nullable: true,
  readOnly: true
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsBoolean)(), __metadata("design:type", Object)], BillingApiChargePayCheckResponseDto.prototype, "hasPaid", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Id сделки",
  format: "uuid",
  readOnly: true
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsUUID)(4), __metadata("design:type", String)], BillingApiChargePayCheckResponseDto.prototype, "orderId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Сделки целиком, если затребована",
  type: () => types_1.BillingApiOrderResponseDto,
  nullable: true,
  readOnly: true
})
/** Сделка к которой */, (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_transformer_1.Type)(() => types_1.BillingApiOrderResponseDto), (0, class_validator_1.ValidateNested)(), __metadata("design:type", Object)], BillingApiChargePayCheckResponseDto.prototype, "order", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Сумма всех начислений (включая уже оплаченные ранее)",
  format: "decimal",
  default: "0.000000",
  readOnly: true
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsString)(), __metadata("design:type", String)], BillingApiChargePayCheckResponseDto.prototype, "amountAll", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Сумма начислений подлежащих оплате (без учёта комиссий и сборов)",
  format: "decimal",
  default: "0.000000",
  readOnly: true
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsString)(), __metadata("design:type", String)], BillingApiChargePayCheckResponseDto.prototype, "amount", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Сумма к оплате (включая комиссии, сборы и т.д.)",
  format: "decimal",
  default: "0.000000",
  readOnly: true
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsString)(), __metadata("design:type", String)], BillingApiChargePayCheckResponseDto.prototype, "amountToPay", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Комиссия процессинга (если null то без комиссии)",
  format: "decimal",
  default: "0.000000",
  readOnly: true,
  nullable: true,
  required: false
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsString)(), __metadata("design:type", String)], BillingApiChargePayCheckResponseDto.prototype, "feeAmount", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Валюта счёта",
  format: "^[A-Z]{3}$",
  example: "USD",
  readOnly: true
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsString)(), (0, class_validator_1.Length)(3, 3), __metadata("design:type", String)], BillingApiChargePayCheckResponseDto.prototype, "currencyCode", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Id начислений",
  format: "uuid",
  readOnly: true
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsUUID)(4, {
  each: true
}), __metadata("design:type", Array)], BillingApiChargePayCheckResponseDto.prototype, "chargeId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Валюта для отображения приблизительного значения",
  format: "^[A-Z]{3}$",
  example: "EUR",
  readOnly: true,
  nullable: true,
  required: false
}), (0, class_validator_1.IsOptional)(), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsString)(), (0, class_validator_1.Length)(3, 3), __metadata("design:type", Object)], BillingApiChargePayCheckResponseDto.prototype, "approximateCurrencyCode", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: `Приблизительная стоимость в запрошенной валюте`,
  format: "decimal",
  default: "0.000000",
  example: null,
  readOnly: true,
  nullable: true,
  required: false
}), (0, class_validator_1.IsOptional)(), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsString)(), __metadata("design:type", Object)], BillingApiChargePayCheckResponseDto.prototype, "approximateAmount", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: `Приблизительная сумма в запрошенной валюте к оплате 
    (включая комиссии, сборы и т.д.)`,
  format: "decimal",
  default: "0.000000",
  readOnly: true,
  nullable: true,
  required: false,
  example: null
}), (0, class_validator_1.IsOptional)(), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsString)(), __metadata("design:type", Object)], BillingApiChargePayCheckResponseDto.prototype, "approximateAmountToPay", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Начисления целиком, если затребованы",
  type: () => billing_api_charge_response_dto_1.BillingApiChargeResponseDto,
  nullable: true,
  readOnly: true,
  isArray: true
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_transformer_1.Type)(() => billing_api_charge_response_dto_1.BillingApiChargeResponseDto), (0, class_validator_1.ValidateNested)({
  each: true
}), __metadata("design:type", Object)], BillingApiChargePayCheckResponseDto.prototype, "charge", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Провайдеры поддрживающие приём платежа",
  type: () => BillingApiChargePayCheckProviderResponseDto,
  readOnly: true,
  isArray: true
}), (0, class_transformer_1.Expose)(), (0, class_transformer_1.Type)(() => BillingApiChargePayCheckProviderResponseDto), (0, class_validator_1.ValidateNested)({
  each: true
}), __metadata("design:type", Array)], BillingApiChargePayCheckResponseDto.prototype, "providers", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Счета подходящие для оплаты",
  type: () => types_2.BillingApiAccountResponseDto,
  readOnly: true,
  isArray: true
}), (0, class_transformer_1.Expose)(), (0, class_transformer_1.Type)(() => types_2.BillingApiAccountResponseDto), (0, class_validator_1.ValidateNested)({
  each: true
}), __metadata("design:type", Array)], BillingApiChargePayCheckResponseDto.prototype, "accounts", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: `Id приоритеного счёта для оплаты (не обязатнельно). Если null, то автовыбор счёта затруднён
      и пользователь должен самостоятельно выбрать подходящий.`,
  type: String,
  format: "uuid",
  nullable: true,
  required: false
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsUUID)(4), __metadata("design:type", Object)], BillingApiChargePayCheckResponseDto.prototype, "selectedAccountId", void 0);
BillingApiChargePayCheckResponseDto = BillingApiChargePayCheckResponseDto_1 = __decorate([(0, class_transformer_1.Exclude)()], BillingApiChargePayCheckResponseDto);
exports.BillingApiChargePayCheckResponseDto = BillingApiChargePayCheckResponseDto;
